
import _ from 'lodash'
const modulesFiles = require.context(`./`, true, /\.vue$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const value = modulesFiles(modulePath)
    if (value.default && value.default.name) {
        const moduleName = _.trimStart(value.default.name.replace(/([A-Z])/g, `_$1`).toUpperCase(), `_`)
        if (modules[moduleName]) {
            console.error(`has a same name :${modulePath}`)
        }
        modules[moduleName] = { uniq_name: moduleName, label: value.default.name, location: modulePath, content: value.default }
    }
    return modules
}, {})

// console.log(modules)
export default modules

// export default {
//   INDEX: () => import('@/components/Index'),
//   KB: () => import('@/components/KnowledgeBase/Index'),
//   KB_INDEX: () => import('@/components/KnowledgeBase/Home'),
//   KB_CLINIC: () => import('@/components/KnowledgeBase/Clinic'),
//   KB_ANNOUNCEMENTS: () => import('@/components/KnowledgeBase/Announcements'),
//   KB_REQUIREMENT: () => import('@/components/KnowledgeBase/Requirement'),
//   SETTINGS: () => import('@/components/Settings/Index'),
//   MEDICALRECORD: () => import('@/components/Medicalrecord/Index'),
//   //  PORTAL: () => import('@/components/Portal/Index'),
//   PORTAL: () => import('@/components/Surgery/SurgeryList'),
//   QUALITYCONTROL: () => import('@/components/Qualitycontrol/Index'),
//   RECOVERY: () => import('@/components/Recovery/Index'),
//   RECOVERY_LIST: () => import('@/components/Recovery/List'),
//   RECOVERY_TODAY: () => import('@/components/Recovery/Today'),
//   RECOVERY_HISTORY: () => import('@/components/Recovery/History'),
//   SCHEDULING: () => import('@/components/Scheduling/Index'),  //  排程
//   //  SECTIONMANAGE: () => import('@/components/SectionManage/Index'),
//   ORGANIZATION: () => import('@/components/Organization/Index'),  //  组织架构
//   ORGANIZATION_SECTION: () => import('@/components/Organization/Section/Index'),
//   ORGANIZATION_HOSPITAL_WARD: () => import('@/components/Organization/HospitalWard/Index'),
//   ORGANIZATION_OPERATION_ROOM: () => import('@/components/Organization/OperationRoom/Index'),
//   ORGANIZATION_OPERATION_WARD: () => import('@/components/Organization/OperationWard/Index'),
//   ORGANIZATION_RECOVERY_BED: () => import('@/components/Organization/RecoveryBed/Index'),
//   ORGANIZATION_RECOVERY_ROOM: () => import('@/components/Organization/RecoveryRoom/Index'),
//   USER: () => import('@/components/SysUser/Index'),
//   WORKER: () => import('@/components/Worker/Index'),
//   ROLE: () => import('@/components/Role/Index'),
//   PERMISSION: () => import('@/components/Permission/Index'),
//   MENU: () => import('@/components/Menu/Index'),
//   SUPPLY: () => import('@/components/Supply/Index'),
//   SUPERVISION: () => import('@/components/Supervision/Index'),
//   SUPERVISION_SURGERY: () => import('@/components/Supervision/Surgery'),
//   SUPERVISION_RECOVERY: () => import('@/components/Supervision/Recovery'),
//   CHARGE: () => import('@/components/Charge/Index'),
//   CHARGE_ANESTHESIA: () => import('@/components/Charge/Anesthesia'),
//   CHARGE_SURGERY: () => import('@/components/Charge/Anesthesia'),
//   CHARGE_RECOVERY: () => import('@/components/Charge/Anesthesia'),
//   CHARGE_ITEM_QUERY: () => import('@/components/Charge/Anesthesia'),
//   CHARGE_QUERY: () => import('@/components/Charge/Anesthesia'),
//   TRANSFER: () => import('@/components/Transfer/Index'),
//   TRANSFER_HANDOVER: () => import('@/components/Transfer/Handover'),
//   TRANSFER_TRACE: () => import('@/components/Transfer/Trace'),
//   SPECIMEN: () => import('@/components/Specimen/Index'),
//   SPECIMEN_TRANSFER_RECORD: () => import('@/components/Specimen/Transfer'),
//   SPECIMEN_TRANSFER_TRACE: () => import('@/components/Specimen/TransferTrace'),
//   ADVERSEEVENT: () => import('@/components/AdverseEvent/Index'),
//   TEMPLATE: () => import('@/components/Template/Index'),
//   TMP_CHARGE_ANESTHESIA: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_CHARGE_SURGERY: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_CHARGE_RECOVERY: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_DOCUMENT: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_MAZUIDAN: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_FUSU: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_HAOCAI: () => import('@/components/Template/ChargeAnesthesia'),
//   TMP_YAOXIANG: () => import('@/components/Template/ChargeAnesthesia'),
//   DEPT_MGT: () => import('@/components/DeptMgt/Index'),
//   STATISTICS: () => import('@/components/Statistics/Index'), //  统计报表
//   ROUTINE: () => import('@/components/Statistics/Routine/Index'), //  常规统计
//   ROUTINE_WORKLOAD: () => import('@/components/Statistics/Routine/Workload/Index'),
//   ROUTINE_ANESTHESIOLOGY: () => import('@/components/Statistics/Routine/Anesthesiology/Index'),
//   ROUTINE_SURGERY: () => import('@/components/Statistics/Routine/Surgery/Index'),
//   ROUTINE_CLINIC_DEPT: () => import('@/components/Statistics/Routine/ClinicDept/Index'),
//   ROUTINE_OPERATION_ROOM: () => import('@/components/Statistics/Routine/OperationRoom/Index'),
//   ROUTINE_RECOVERY_ROOM: () => import('@/components/Statistics/Routine/RecoveryRoom/Index'),
//   HOSPITAL: () => import('@/components/Statistics/Hospital/Index'), //  三级综合医院统计指标
//   QCH_ASA: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_ANESTHESIA_C_M: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_ANESTHESIA_C_Q: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_RECOVERY_M: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_RECOVERY_Q: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_SUSAR_M: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_QNALGESIA_Q: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QCH_CPR_Q: () => import('@/components/Statistics/Hospital/QchAsa'),
//   QUALITY: () => import('@/components/Statistics/Quality/Index'), //  国家指标
//   MGT: () => import('@/components/Statistics/Quality/Mgt'),
//   QA: () => import('@/components/Statistics/Quality/Qa'),
//   COM: () => import('@/components/Statistics/Quality/Com'),
//   MGT_1: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_2: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_3: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_4: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_5: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_6: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_7: () => import('@/components/Statistics/Quality/Mgt1'),
//   MGT_8: () => import('@/components/Statistics/Quality/Mgt1'),
//   SURGERYLIST: () => import('@/components/Surgery/SurgeryList'),  //  手术卡片、列表
//   DIC: () => import('@/components/Dictionary/Index'),  //  基础字典
//   DIC_DISEASES:() => import('@/components/Dictionary/Disease/Index'),

//   //  二级目录
//   SURGERY: () => import('@/components/Surgery/Index'),
//   ANESTHESIA_RECORDS: () => import('@/components/Surgery/AnesthesiaRecords/Index2'),
//   HANDOVER_NURSE: () => import('@/components/Surgery/HandoverNurse/Index'),
//   POSTOPERATION: () => import('@/components/Surgery/Postoperation/Index'),
//   SURGERY_CHARGE: () => import('@/components/Surgery/SurgeryCharge/Index'),
//   ADVERSE: () => import('@/components/Surgery/Adverse/Index'),
//   PRESCRIPTION: () => import('@/components/Surgery/prescription/Index'),
//   SCORE: () => import('@/components/Surgery/Score/Index'),
//   EXAM: () => import('@/components/Surgery/Exam/Index'),
//   LIS: () => import('@/components/Surgery/Lis/Index'),
//   MEDICAL_HISTORY: () => import('@/components/Surgery/MedicalHistory/Index'),
//   MEDICAL_RECORD: () => import('@/components/Surgery/MedicalRecord/Index'),
//   RECOVERY_CHARGE: () => import('@/components/Surgery/RecoveryCharge/Index'),
//   ANESTHESIA_CHARGE: () => import('@/components/Surgery/AnesthesiaCharge/Index'),
//   BLOOD: () => import('@/components/Surgery/Blood/Index'),
//   PATHOLOGY: () => import('@/components/Surgery/Pathology/Index'),
//   CONSUMABLE: () => import('@/components/Surgery/Consumable/Index'),
//   INSTRUMENT_INVENTORY: () => import('@/components/Surgery/InstrumentInventory/Index'),
//   SECURITY_CHECK: () => import('@/components/Surgery/SecurityCheck/Index'),
//   DOCUMENT: () => import('@/components/Surgery/Document/Index'),
//   RECOVERY_RECORDS: () => import('@/components/Surgery/RecoveryRecords/Index'),
//   MEMO: () => import('@/components/Surgery/MEMO/Index'),
// }



// WEBPACK FOOTER //
// ./src/components/componentDefinition.js